export const ASIDE_ALPHABET_WIDTH = '28px'
